exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table .highlight{background-color:#dff0d8}.el-table .bold{font-weight:700}", ""]);

// exports
